import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const FinancingSourcesSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="financingSourcesSection"
      title={t('client.client.financingSources.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
